import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import {
  TenantDetailsPageLoader,
  TenantDetailsLeaseLoader,
  TenantDetailsLeaseAction,
  TenantDetailsPageAction,
} from "./TenantDetailsPage/loaders";
import {
  TenantTablePageAction,
  TenantTablePageLoader,
} from "./TenantTablePage/loaders";
import { ROUTES } from "~/utils";
import {
  AddTenantPageLoader,
  AddTenantPageAction,
} from "./AddTenantPage/loaders";

const AddTenantPage = lazyNamedPage("AddTenantPage", () =>
  import(/* webpackChunkName: "tenant" */ "./AddTenantPage/AddTenantPage"),
);
const TenantTablePage = lazyNamedPage("TenantTablePage", () =>
  import(
    /* webpackChunkName: "tenant" */
    "./TenantTablePage/TenantTablePage"
  ),
);
const TenantDetailsPage = lazyNamedPage("TenantDetailsPage", () =>
  import(
    /* webpackChunkName: "tenant" */
    "./TenantDetailsPage/TenantDetailsPage"
  ),
);
const TenantDetailsLease = lazyNamedPage("TenantDetailsLease", () =>
  import(
    /* webpackChunkName: "tenant" */
    "./TenantDetailsPage/TenantDetailsLease"
  ),
);

export const TenantPagesRoutes = () => {
  return (
    <>
      {/* TODO: remove this route, as all tenants should be added using the tenant sign up */}
      <Route
        path={ROUTES.addTenant}
        loader={AddTenantPageLoader}
        action={AddTenantPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<AddTenantPage />}
      />
      <>
        <Route
          loader={TenantTablePageLoader}
          action={TenantTablePageAction}
          ErrorBoundary={() => SimpleErrorBoundary()}
          path={ROUTES.tenantTable}
          element={<TenantTablePage />}
        />
        <Route
          loader={TenantDetailsPageLoader}
          action={TenantDetailsPageAction}
          ErrorBoundary={() => SimpleErrorBoundary()}
          path={ROUTES.tenantDetails}
          element={<TenantDetailsPage />}
        >
          <Route
            path={ROUTES.tenantDetailsLease}
            loader={TenantDetailsLeaseLoader}
            action={TenantDetailsLeaseAction}
            ErrorBoundary={() => SimpleErrorBoundary()}
            element={<TenantDetailsLease />}
          />
        </Route>
      </>
    </>
  );
};
